// extracted by mini-css-extract-plugin
export var currencyInput = "_mr-1";
export var currencySymbol = "_mr-0";